<template>
	<div>
		<el-dialog :visible.sync="showpaytypewin" title="会员充值"
			width="600px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<div style="height:320px;margin-top:-20px" align="center">
				<table class="htmltable">
					<tr>
						<td class="title">兑换关系:</td>
						<td>{{ chargefromamount }} 人民币 ≈ {{ chargeamount }} 美元</td>
					</tr>
					<tr style="height:10px"><td colspan="2"></td></tr>
					<tr>
						<td class="title">充值金额:</td>
						<td style="text-align:left;">
							<el-input type="Number" v-model="amount" @input="collectfee" size="mini" style="width:150px" @focus="focus($event)"></el-input>
							<span style="padding-left:5px">元</span>
						</td>
					</tr>
				</table>
				<el-divider content-position="left">选择支付方式</el-divider>
				<el-row :gutter="12">
					<el-col :span="6" v-for="(item, index) in paytype" :key="index">
						<el-card :shadow="item.selected ? 'always' : 'hover'" :style="{width:'120px',height:'55px', borderWidth:'2px',borderStyle:'2px',borderColor:item.selected?'#F9A51D':''}" :body-style="{ padding:'10px' }">
							
								<img :src="item.image" style="width:100%;cursor:pointer;" @click="selectpay(item)" />
							
							<!-- <div class="right clearfix" style="text-align:right;">
									<el-tag v-if="item.selected" :disable-transitions="true" type="warning" size="mini" effect="dark">已选</el-tag>
							</div> -->
						</el-card>
					</el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<div style="text-align: center;">
					<el-button type="warning" :disabled="chargedisabled" >
						<a :href="payurl" target="_blank" :disabled="chargedisabled" @click="surepay" style="text-decoration: none;color: white;">确认充值</a>
					</el-button>
					<el-button @click="showpaytypewin = false">取消</el-button>
				</div>
			</span>
		</el-dialog>
		<el-dialog
		      width="40%"
		      title="支付提示"
		      :visible.sync="showpaytips"
		      :close-on-click-modal="false" 
			  lock-scroll :modal-append-to-body="false" :show-close="false">
			  <span style="font-size:15pt;font-weight:bold;">请在新打开的支付页面进行支付，支付完成前不要关闭该窗口哦</span>
			  <div slot="footer" class="dialog-footer">
			        <el-button @click="paysuccess" type="success">已完成支付</el-button>
			        <el-button @click="showpaytips=false">返回</el-button>
			   </div>
		   </el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	data() {
		return {
			showpaytypewin: false,
			payparam:{},
			chargedisabled:true,
			paytype: [
				{
					p_paytype: '微信', //充值方式名称
					sign: 'native', //充值方式标识,
					image: this.$tool.getpayicon('微信'), //充值图标
					selected: true
				}
				// ,{
				// 	p_paytype:'支付宝',//充值方式名称
				// 	sign:'native1',//充值方式标识,
				// 	image:this.$tool.getpayicon('支付宝'),//充值图标
				// 	selected:false
				// }
			],
			payurl:'',
			showpaytips:false,
			chargefrom: 'CNY',
			chargerate: 0,
			chargeamount: 0,
			chargefromamount: 1,
			amount: 0,
			handlefee: 0,
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/selectpaytype.scss');
		});
	},
	methods: {
		//初始加载
		init(param) {
			this.$apipost.get.getTheme().then(res => {
				import('../../static/' + res + '/style/cw/selectpaytype.scss');
			});
			this.showpaytypewin = true;
			this.payparam={};
			this.chargedisabled=true;
			this.payurl='';
			this.showpaytips=false;
			this.chargerate = 0;
			this.chargeamount = 0;
			this.amount = 0;
			this.description=param.description;
			localStorage.removeItem('payparam');//移除支付参数
			this.GetChargeRate();
			if (param != undefined){
				this.setpayparam();
			}
		},
		focus(event) {
			event.currentTarget.select();
		},
		//获取汇率
		GetChargeRate() {
			var that = this;
			var paraminfo = {
				chargecurrency: this.chargefrom,
				userid: localStorage.getItem('userid')
			};
			this.$apipost.get.GetChargeRate({ paraminfo: paraminfo }).then(res => {
				if (res.state == '1') {
					that.chargerate = res.rate;
					//查询手续费
					that.$apipost.get.GetSystemParam({ showname: '充值手续费', type: 1 }).then(res => {
						if (res.state != undefined) {
							that.handlefee = parseFloat(res.state);
							that.chargeamount = (parseFloat(1) * that.chargerate - parseFloat(1) * that.chargerate * that.handlefee).toFixed(4);
						}
					});
				}
			});
		},
		//计算金额
		collectfee(val) {
			if (val != '' && val != '0') {
				if(isNaN(val))
					return false;
				if(parseFloat(val)<=0)
					return false;
				this.chargeamount = (parseFloat(val) * this.chargerate - parseFloat(val) * this.chargerate * this.handlefee).toFixed(4);
				this.chargefromamount = val;
				this.setpayparam();
			} else {
				this.chargedisabled = true;
				this.chargefromamount = 1;
			}
		},
		selectpay(item) {
			this.paytype.forEach(e => {
				e.selected = false;
			});
			item.selected = true;
			this.setpayparam();
		},
		//设置参数
		setpayparam(){
			var paytype='',sign='';
			this.paytype.forEach(e => {
				if(e.selected){
					paytype=e.p_paytype;
					sign=e.sign;
					return false;
				}
			});
			if(paytype!=''){
				this.payparam={
					chargecurrency: this.chargefrom,
					amount: this.amount,
					p_paytype: paytype,
					vipaccount:localStorage.getItem('vipaccount'),
					userid: localStorage.getItem('userid'),
					sign: sign,
					description:this.description
				}
			}
			else{
				this.chargedisabled=true;
			}
			if(this.payparam.amount!=undefined&&this.payparam.p_paytype!=undefined&&this.payparam.vipaccount!=undefined&&this.payparam.sign!=undefined){
				if(parseFloat(this.payparam.amount)>0){
					this.chargedisabled=false;
					localStorage.removeItem('payparam');//移除支付参数
					localStorage.setItem('payparam',JSON.stringify(this.payparam));
					this.payurl='../#/pay';
				}
			}else{
				this.chargedisabled=true;
			}
		},
		//确认支付
		surepay(){
			if(this.payurl!=''){
				localStorage.removeItem('paystate');//移除支付状态
				localStorage.removeItem('payno');//移除支付单号
				this.showpaytips=true;
			}
		},
		paysuccess(){
			var that=this;
			if(localStorage.getItem('paystate')=='1'){
				that.showpaytips=false;
				that.showpaytypewin = false;
				that.$parent.getvipaccount();
				localStorage.removeItem('paystate');//移除支付状态
			}else{
				var payno=localStorage.getItem('payno');
				if(payno!=undefined&&payno!=''){
					var payparam = {
							p_paytype: this.p_paytype,
							sn: payno
						};
					this.$apipost.get.getpayorder({ payparam: payparam }).then(res => {
						if (res.state == '1') {
							that.showpaytips=false;
							that.showpaytypewin = false;
							//debugger;
							that.$parent.getvipaccount();
						}else{
							that.$tool.message('请在打开的新页面中扫码支付',0,3000);
						}
					});
				}
			}
		}
	}
};
</script>

<style></style>
